import React from "react";

/**
 * Lightweight, removable BETA ribbon shown on logged-in app surfaces and
 * the marketing homepage so testers know this is an early-access build.
 *
 * To remove for GA: delete this file and its imports — no other coupling.
 */
export const BetaRibbon = () => {
  const isBeta =
    (process.env.REACT_APP_ENV || "").toLowerCase() !== "production";

  if (!isBeta) return null;

  return (
    <div
      data-testid="beta-ribbon"
      className="w-full bg-blue-600 text-white text-xs sm:text-sm py-1.5 px-4 text-center tracking-wide font-medium shadow-sm"
    >
      <span className="opacity-90">
        BETA · You&rsquo;re using an early-access build of Inter-View. Feedback
        welcome.
      </span>
    </div>
  );
};

export default BetaRibbon;
